export function Pagination({
  currentPage,
  pageSize,
  totalCount,
  onPageChange
}: {
  currentPage: number;
  pageSize: number;
  totalCount: number;
  onPageChange(page: number): void;
}) {
  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));
  if (totalPages <= 1) return null;

  const pageNumbers: (number | "ellipsis")[] = [];
  for (let i = 1; i <= totalPages; i++) {
    if (i === 1 || i === totalPages || (i >= currentPage - 1 && i <= currentPage + 1)) {
      pageNumbers.push(i);
    } else if (pageNumbers[pageNumbers.length - 1] !== "ellipsis") {
      pageNumbers.push("ellipsis");
    }
  }

  return (
    <div className="pagination">
      <span className="pagination-info">
        {totalCount} total
      </span>
      <button
        className="pagination-btn"
        disabled={currentPage <= 1}
        onClick={() => onPageChange(currentPage - 1)}
        type="button"
      >
        ← Prev
      </button>
      {pageNumbers.map((p, i) =>
        p === "ellipsis" ? (
          <span key={`e-${i}`} className="pagination-ellipsis">…</span>
        ) : (
          <button
            key={p}
            className={`pagination-btn${p === currentPage ? " active" : ""}`}
            onClick={() => onPageChange(p)}
            type="button"
          >
            {p}
          </button>
        )
      )}
      <button
        className="pagination-btn"
        disabled={currentPage >= totalPages}
        onClick={() => onPageChange(currentPage + 1)}
        type="button"
      >
        Next →
      </button>
    </div>
  );
}
